module.exports = __webpack_public_path__ + "static/img/973_phase_function_Paper_PointsHejduk_Prediction.bf6a5fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/973_phase_function_Paper_PointsHejduk_Prediction.png
// module id = NdDe
// module chunks = 0